<header>
	<app-cms-header (menuToggle)="toggleMobileMenu()"></app-cms-header>
</header>

<section class="page">
	<div class="sidebar" [class.active]="mobileMenuActive" [class.collapsed]="sidenavCollapsed()">
		<app-cms-sidenav
			[collapsed]="sidenavCollapsed"
			(closeMenuEmitter)="onMenuClose()"
			(collapseToggle)="toggleCollapse()"
		></app-cms-sidenav>
	</div>
	<div class="content">
		<router-outlet></router-outlet>
	</div>
</section>

<div class="mobile-backdrop" [class.visible]="mobileMenuActive" (click)="onMenuClose()"></div>

<app-notifications-sidenav></app-notifications-sidenav>
